import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { MemberDetail } from '@/types/admin-settings';

const CACHE_KEY = 'admin-member-detail';

export function useMemberDetail(userId: string) {
    const { data, isLoading, error, mutate } = useSWR<MemberDetail>(
        [CACHE_KEY, userId],
        () => AdminSettingsService.getMemberDetail(userId),
        { revalidateOnFocus: false },
    );

    return {
        member: data,
        isLoading,
        error,
        mutate,
    };
}
